module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form container"
  }, [(!_vm.showForm) ? _c('div', [_c('Register', {
    on: {
      "showFormChanged": _vm.showFormChange
    }
  }), _vm._v(" "), _c('Login', {
    on: {
      "showFormChanged": _vm.showFormChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-article formResponsive formHorizontal"
  }, [(!_vm.showForm) ? _c('div', {
    staticClass: "formCover"
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-article-item choose"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Choose or Propose an Entry")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Browse the lists below in order to choose an entry")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "inline tit2"
  }, [_vm._v("Choose from all terms")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entry.id),
      expression: "entry.id"
    }],
    staticClass: "inline",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entry, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.entry.english = '', _vm.entry.new = false, _vm.selectListLexical()
      }]
    }
  }, [_c('option', {
    attrs: {
      "label": "Choose a Term"
    }
  }), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Epistemologies"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 1) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "History and Genealogy"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 2) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Cultural Practices and Performativities"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 3) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Linguistic Uses -  Terms"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 4) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Linguistic Uses - Lexical Units"
    }
  }, _vm._l((_vm.apiLexicalUnits), function(term) {
    return _c('option', {
      domProps: {
        "value": 'lu-' + term.id
      }
    }, [_vm._v(_vm._s(term.term_english))])
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Arts, Literatures and imaginaries"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 5) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tit2"
  }, [_vm._v("or")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tit2"
  }, [_vm._v("Propose a New Entry")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "inline"
  }, [_vm._v("in english")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entry.english),
      expression: "entry.english"
    }],
    staticClass: "inline",
    attrs: {
      "type": "text",
      "name": ""
    },
    domProps: {
      "value": (_vm.entry.english)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entry, "english", $event.target.value)
      }, function($event) {
        _vm.entry.id = '', _vm.entry.new = true
      }]
    }
  })])]), _vm._v(" "), (_vm.entry.new) ? _c('div', {
    staticClass: "form-article-item create",
    staticStyle: {
      "margin-top": "-40px"
    }
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Thematic Sections")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Associate the New Entry to a Thematic Section.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "rsform-block",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('div', {
    staticClass: "formControls"
  }, [_c('div', {
    staticClass: "formBody"
  }, [_c('div', {
    staticClass: "rsformgrid6"
  }, [_c('p', {
    staticClass: "rsformVerticalClear"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "Periodohistorico20"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entry.section),
      expression: "entry.section"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.entry.section, "1")
    },
    on: {
      "input": function($event) {
        _vm.entry.lexical = false
      },
      "change": function($event) {
        return _vm.$set(_vm.entry, "section", "1")
      }
    }
  }), _vm._v("\n                  Epistemologies\n                  "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "rsformVerticalClear"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "Periodohistorico20"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entry.section),
      expression: "entry.section"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.entry.section, "2")
    },
    on: {
      "input": function($event) {
        _vm.entry.lexical = false
      },
      "change": function($event) {
        return _vm.$set(_vm.entry, "section", "2")
      }
    }
  }), _vm._v("\n                  History and Genealogy\n                  "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "rsformVerticalClear"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "Periodohistorico20"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entry.section),
      expression: "entry.section"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.entry.section, "3")
    },
    on: {
      "input": function($event) {
        _vm.entry.lexical = false
      },
      "change": function($event) {
        return _vm.$set(_vm.entry, "section", "3")
      }
    }
  }), _vm._v("\n                  Cultural Practices\n                  "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "rsformVerticalClear"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "Periodohistorico20"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entry.section),
      expression: "entry.section"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.entry.section, "4")
    },
    on: {
      "input": function($event) {
        _vm.entry.lexical = false
      },
      "change": function($event) {
        return _vm.$set(_vm.entry, "section", "4")
      }
    }
  }), _vm._v("\n                  Linguistic Uses\n                  "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "rsformVerticalClear"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "Periodohistorico20"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entry.section),
      expression: "entry.section"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio",
      "value": "5"
    },
    domProps: {
      "checked": _vm._q(_vm.entry.section, "5")
    },
    on: {
      "input": function($event) {
        _vm.entry.lexical = false
      },
      "change": function($event) {
        return _vm.$set(_vm.entry, "section", "5")
      }
    }
  }), _vm._v("\n                  Arts, Literatures and imaginaries\n                  "), _c('span', {
    staticClass: "checkmark"
  })])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.entry.section == '4') ? _c('div', {
    staticClass: "rsform-block"
  }, [_c('div', {
    staticClass: "formControls"
  }, [_c('div', {
    staticClass: "formBody"
  }, [_c('div', {
    staticClass: "rsformgrid6"
  }, [_c('p', {
    staticClass: "rsformVerticalClear"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "Periodohistorico20"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entry.lexical),
      expression: "entry.lexical"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.entry.lexical, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.entry, "lexical", false)
      }
    }
  }), _vm._v("\n                  Term\n                  "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "rsformVerticalClear"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "Periodohistorico20"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entry.lexical),
      expression: "entry.lexical"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.entry.lexical, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.entry, "lexical", true)
      }
    }
  }), _vm._v("\n                  Lexical Unit\n                  "), _c('h5', [_vm._v("(word to be defined as loan word from another source language; only loans between African and European languages should be considered)")]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.entry.lexical) ? _c('div', {
    staticClass: "form-article-item article"
  }, [_c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Article")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.name_language),
      expression: "article.name_language"
    }],
    attrs: {
      "type": "text",
      "name": ""
    },
    domProps: {
      "value": (_vm.article.name_language)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "name_language", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.title),
      expression: "article.title"
    }],
    attrs: {
      "type": "text",
      "name": ""
    },
    domProps: {
      "value": (_vm.article.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("You may propose a title to your article in order to clarify the focus or approach to the Term/Entry. Max. 150 carat.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
    model: {
      value: (_vm.article.body),
      callback: function($$v) {
        _vm.$set(_vm.article, "body", $$v)
      },
      expression: "article.body"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Illustrations")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Optional (Maximum 1 image)")]), _vm._v(" "), _c('input', {
    staticClass: "imageinput",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.uploadImage
    }
  }), _vm._v(" "), _c('p', [_vm._v("Pictures (Photos, Drawings, etc). Allowed files: .jpg .png .gif")]), _vm._v(" "), (_vm.article.img_url) ? _c('div', {
    staticClass: "image-consent"
  }, [_c('label', {
    staticClass: "container2 inline",
    attrs: {
      "for": "expressconsent0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.img_auth),
      expression: "article.img_auth"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "checkbox",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.article.img_auth) ? _vm._i(_vm.article.img_auth, "true") > -1 : (_vm.article.img_auth)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.article.img_auth,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.article, "img_auth", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.article, "img_auth", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.article, "img_auth", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('p', {
    staticClass: "inline"
  }, [_vm._v("\n            The user declares that the submitted content has a Creative Commons License or is\n            covered by copyright to which they have a valid license.\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Keywords")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Please write your keywords in english (maximum 3).")]), _vm._v(" "), _c('div', {
    staticClass: "rsform-block"
  }, [_c('div', {
    staticClass: "formControls"
  }, [_c('div', {
    staticClass: "formBody"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.keyword1),
      expression: "article.keyword1"
    }],
    staticClass: "rsform-input-box",
    attrs: {
      "type": "text",
      "value": "",
      "size": "20",
      "placeholder": "1."
    },
    domProps: {
      "value": (_vm.article.keyword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "keyword1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "formDescription"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "rsform-block"
  }, [_c('div', {
    staticClass: "formControls"
  }, [_c('div', {
    staticClass: "formBody"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.keyword2),
      expression: "article.keyword2"
    }],
    staticClass: "rsform-input-box",
    attrs: {
      "type": "text",
      "value": "",
      "size": "20",
      "placeholder": "2."
    },
    domProps: {
      "value": (_vm.article.keyword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "keyword2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "formDescription"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "rsform-block"
  }, [_c('div', {
    staticClass: "formControls"
  }, [_c('div', {
    staticClass: "formBody"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.keyword3),
      expression: "article.keyword3"
    }],
    staticClass: "rsform-input-box",
    attrs: {
      "type": "text",
      "value": "",
      "size": "20",
      "placeholder": "3."
    },
    domProps: {
      "value": (_vm.article.keyword3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "keyword3", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "formDescription"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Hyperlinks")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Choose a maximum of 3 hyperlinks to other terms.")]), _vm._v(" "), _c('span', {
    staticClass: "tit2"
  }, [_vm._v("All Terms (A-Z)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.currentLink),
      expression: "article.currentLink"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.article, "currentLink", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "label": "Choose a Term"
    }
  }), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Epistemologies"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 1) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "History and Genealogy"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 2) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Cultural Practices and Performativities"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 3) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Linguistic Uses"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 4) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Arts, Literatures and imaginaries"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 5) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addLink(_vm.article.currentLink)
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_vm._l((_vm.article.linkList), function(link) {
    return _c('li', _vm._l((_vm.apiTerms), function(term) {
      return (term.id === link) ? _c('span', [_vm._v("\n              " + _vm._s(term.term_english) + " -\n              "), _c('button', {
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.removeLink(_vm.article.currentLink)
          }
        }
      }, [_vm._v("Remove")])]) : _vm._e()
    }), 0)
  }), _vm._v(" "), (_vm.article.linkValidation) ? _c('p', [_vm._v("Maximum 3 Links")]) : _vm._e()], 2), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Bibliographic References")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
    model: {
      value: (_vm.article.references),
      callback: function($$v) {
        _vm.$set(_vm.article, "references", $$v)
      },
      expression: "article.references"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Include 3 to 5 bibliographic references within a maximum of 1000 characters (total).")]), _vm._v(" "), _c('p', [_vm._v("The references must follow the Publication Guidelines.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Author")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tit2"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.author.surname),
      expression: "article.author.surname"
    }],
    staticClass: "inline",
    attrs: {
      "type": "text",
      "placeholder": "Surname"
    },
    domProps: {
      "value": (_vm.article.author.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.author, "surname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.author.firstName),
      expression: "article.author.firstName"
    }],
    staticClass: "inline",
    attrs: {
      "type": "text",
      "placeholder": "First name and middle name"
    },
    domProps: {
      "value": (_vm.article.author.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.author, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tit2"
  }, [_vm._v("Affiliation and Funding Reference")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.author.affiliation),
      expression: "article.author.affiliation"
    }],
    domProps: {
      "value": (_vm.article.author.affiliation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.author, "affiliation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Máx 300 carat.")]), _vm._v(" "), _c('p', [_vm._v("I agree that my e-mail be published with the signature of the article.")]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "expressconsent0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.author.mail),
      expression: "article.author.mail"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.article.author.mail, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.article.author, "mail", true)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('p', [_vm._v("YES")])]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "expressconsent0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.author.mail),
      expression: "article.author.mail"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.article.author.mail, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.article.author, "mail", false)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('p', [_vm._v("NO")])])])]) : _vm._e(), _vm._v(" "), (_vm.entry.lexical) ? _c('div', {
    staticClass: "form-article-item lexical"
  }, [_c('div', [_c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tit"
  }, [_vm._v("Languages")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "inline"
  }, [_vm._v("Target Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.lang_occu_id),
      expression: "definition.lang_occu_id"
    }],
    staticClass: "inline",
    staticStyle: {
      "width": "80px !important"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.definition, "lang_occu_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.langSelect('european')
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0"
    }
  }, [_vm._v("European")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
    return (lang.euro === 1) ? _c('option', {
      domProps: {
        "value": lang.id
      }
    }, [_vm._v(_vm._s(lang.name))]) : _vm._e()
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.lang_occu_id),
      expression: "definition.lang_occu_id"
    }],
    staticClass: "inline",
    staticStyle: {
      "width": "80px !important"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.definition, "lang_occu_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.langSelect('african')
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0"
    }
  }, [_vm._v("African")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
    return (lang.afro === 1) ? _c('option', {
      domProps: {
        "value": lang.id
      }
    }, [_vm._v(_vm._s(lang.name))]) : _vm._e()
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.occurrence),
      expression: "definition.occurrence"
    }],
    staticClass: "inline",
    staticStyle: {
      "width": "270px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Write the lexical unit in the target language",
      "name": ""
    },
    domProps: {
      "value": (_vm.definition.occurrence)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.definition, "occurrence", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "inline"
  }, [_vm._v("Source Language")]), _vm._v(" "), (_vm.definition.langOriginSelected && _vm.definition.langOriginSelected == 'african') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.lang_orig_id),
      expression: "definition.lang_orig_id"
    }],
    staticClass: "inline",
    staticStyle: {
      "width": "80px !important"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.definition, "lang_orig_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0"
    }
  }, [_vm._v("European")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
    return (lang.euro === 1) ? _c('option', {
      domProps: {
        "value": lang.id
      }
    }, [_vm._v(_vm._s(lang.name))]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.definition.langOriginSelected && _vm.definition.langOriginSelected == 'european') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.lang_orig_id),
      expression: "definition.lang_orig_id"
    }],
    staticClass: "inline",
    staticStyle: {
      "width": "80px !important"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.definition, "lang_orig_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0"
    }
  }, [_vm._v("African")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
    return (lang.afro === 1) ? _c('option', {
      domProps: {
        "value": lang.id
      }
    }, [_vm._v(_vm._s(lang.name))]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.origin),
      expression: "definition.origin"
    }],
    staticClass: "inline",
    staticStyle: {
      "width": "270px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Write the lexical unit in the language of origin",
      "name": ""
    },
    domProps: {
      "value": (_vm.definition.origin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.definition, "origin", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-article-item form-article-item-lexical"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Grammatical Category")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.category),
      expression: "definition.category"
    }],
    staticClass: "inline",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.definition, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0"
    }
  }, [_vm._v("Choose a Category")]), _vm._v(" "), _vm._l((_vm.apiGramCategories), function(cat) {
    return _c('option', {
      domProps: {
        "value": cat.id
      }
    }, [_vm._v(_vm._s(cat.long_name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-article-item form-article-item-lexical"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Definition")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
    model: {
      value: (_vm.definition.meaning),
      callback: function($$v) {
        _vm.$set(_vm.definition, "meaning", $$v)
      },
      expression: "definition.meaning"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Maximum of 1500 characters (total).")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-article-item form-article-item-lexical"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Synonyms")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
    model: {
      value: (_vm.definition.synonyms),
      callback: function($$v) {
        _vm.$set(_vm.definition, "synonyms", $$v)
      },
      expression: "definition.synonyms"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Maximum of 100 characters (total).")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
    model: {
      value: (_vm.definition.notes),
      callback: function($$v) {
        _vm.$set(_vm.definition, "notes", $$v)
      },
      expression: "definition.notes"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Maximum of 1500 characters (total). These notes will be published with the definition of the lexical unit")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Bibliographic References")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
    model: {
      value: (_vm.definition.references),
      callback: function($$v) {
        _vm.$set(_vm.definition, "references", $$v)
      },
      expression: "definition.references"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Include 3 to 5 bibliographic references within a maximum of 1000 characters (total).")]), _vm._v(" "), _c('p', [_vm._v("The references must follow the Publication Guidelines.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Author")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tit2"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.author.surname),
      expression: "definition.author.surname"
    }],
    staticClass: "inline",
    attrs: {
      "type": "text",
      "placeholder": "Surname"
    },
    domProps: {
      "value": (_vm.definition.author.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.definition.author, "surname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.author.firstName),
      expression: "definition.author.firstName"
    }],
    staticClass: "inline",
    attrs: {
      "type": "text",
      "placeholder": "First name and middle name"
    },
    domProps: {
      "value": (_vm.definition.author.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.definition.author, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tit2"
  }, [_vm._v("Affiliation and Funding Reference")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.author.affiliation),
      expression: "definition.author.affiliation"
    }],
    domProps: {
      "value": (_vm.definition.author.affiliation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.definition.author, "affiliation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Máx 300 carat.")]), _vm._v(" "), _c('p', [_vm._v("I agree that my e-mail be published with the signature of the article.")]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "expressconsent0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.author.mail),
      expression: "definition.author.mail"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.definition.author.mail, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.definition.author, "mail", true)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('p', [_vm._v("YES")])]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "expressconsent0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.definition.author.mail),
      expression: "definition.author.mail"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.definition.author.mail, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.definition.author, "mail", false)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('p', [_vm._v("NO")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-article-item outro"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Terms of Use & Copyright")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("I agree with the Terms of Use and Copyright of the Afro-European Cartography of Culture Language and Arts.")]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "expressconsent0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyright),
      expression: "copyright"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "checked": "",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.copyright, true)
    },
    on: {
      "change": function($event) {
        _vm.copyright = true
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('p', [_vm._v("YES")])]), _vm._v(" "), _c('div', {
    staticClass: "inline"
  }, [_c('label', {
    staticClass: "container2",
    attrs: {
      "for": "expressconsent0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copyright),
      expression: "copyright"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.copyright, false)
    },
    on: {
      "change": function($event) {
        _vm.copyright = false
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('p', [_vm._v("NO")])])]), _vm._v(" "), _c('p', [_vm._v("For assistance with submitting your article please contact glossary@africaneuropeanarratives.eu")]), _vm._v(" "), _c('input', {
    attrs: {
      "value": "Submit",
      "type": "submit",
      "name": ""
    },
    on: {
      "click": function($event) {
        return _vm.validateEntry()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "validation"
  }, [_vm._v(_vm._s(_vm.validation))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-article-item intro"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Submit an Entry")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("to the African-European Cartography of Culture, Language and Arts")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n        We advise you to go through the whole form and read the Publication\n        Guidelines [\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/static/pdf/190619_glossario_Submissao&Normasdepublicacao_EN.pdf"
    }
  }, [_vm._v("pdf eng")]), _vm._v("\n        |\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/static/pdf/190502_glossario_Submissao&Normasdepublicacao.pdf"
    }
  }, [_vm._v("pdf pt")]), _vm._v(" ]\n        before starting the submission of your article.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n          Term\n          "), _c('p', [_vm._v("(In the language of your article)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n          Title\n          "), _c('p', [_vm._v("(optional)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          \"The article can have 6500 to 7000 characters long. Please check the Norms of Publication in the Submission Guidelines document [\n          "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/static/pdf/190619_glossario_Submissao&Normasdepublicacao_EN.pdf"
    }
  }, [_vm._v("pdf eng")]), _vm._v("\n          |\n          "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/static/pdf/190502_glossario_Submissao&Normasdepublicacao.pdf"
    }
  }, [_vm._v("pdf pt")]), _vm._v(" ] .\n          For quotations use H6 in the Headings menu.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-efbd259a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Submit.vue
// module id = 173
// module chunks = 2